package com.nonopn.skydome.common.app.pages.dashboard.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nonopn.skydome.common.app.api.model.DashboardImpactReportV2
import com.nonopn.skywatcher.design.theme.AppColor
import kotlin.math.roundToInt
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.polarity_cg_negative
import com.nonopn.skywatcher.common.app.res.polarity_cg_positive
import com.nonopn.skywatcher.common.app.res.polarity_cg_title
import org.jetbrains.compose.resources.stringResource

object DashboardColors {
    val positiveColor = Color(0xffe63b2e)
    val negativeColor = Color(0xff2b7fe0)
    val negativeColorCardTransparent = Color(0xffe9f0fc)
    val positiveColorCardTransparent = Color(0xfff8ecef)

    val titleColor = Color(0xff64748b)
}

@Composable
fun PolarityReport(modifier: Modifier, negPosCount: DashboardImpactReportV2.NegPosCount) {
    InternalCard(
        modifier = modifier,
        title = stringResource(Res.string.polarity_cg_title)
    ) {
        PolarityLine(
            title = stringResource(Res.string.polarity_cg_negative),
            count = negPosCount.negative,
            total = negPosCount.total(),
            color = DashboardColors.negativeColor
        )

        Spacer(modifier = Modifier.height(8.dp))

        PolarityLine(
            title = stringResource(Res.string.polarity_cg_positive),
            count = negPosCount.positive,
            total = negPosCount.total(),
            color = DashboardColors.positiveColor
        )
    }
}

@Composable
private fun PolarityLine(
    title: String,
    count: Int,
    total: Int,
    color: Color,
) {
    val ratio = if (total == 0) {
        0.0f
    } else {
        count * 1.0f / total
    }

    Row {
        Text(
            text = title,
            color = color,
            fontWeight = FontWeight.Bold
        )

        Spacer(
            modifier = Modifier.weight(1.0f)
        )

        val percent = if (!ratio.isNaN()) {
            "${(ratio * 100).roundToInt()} %"
        } else {
            "- %"
        }

        Text(
            text = percent,
            color = color,
            fontWeight = FontWeight.Bold
        )
    }

    Spacer(modifier = Modifier.height(4.dp))

    Row {
        if (ratio > 0.0f) {
            Column(
                modifier = Modifier.weight(ratio)
                    .clip(RoundedCornerShape(5.dp))
                    .background(color)
                    .padding(4.dp),
            ) {
                Text(
                    text = "$count",
                    color = AppColor.White,
                    fontSize = 14.sp,
                    fontWeight = FontWeight.Bold
                )
            }
        }

        if (ratio < 1.0f) {
            Spacer(
                modifier = Modifier.weight(1.0f - ratio).background(
                    Color(0xffe3ecf7)
                )
            )
        }
    }
}

@Preview
@Composable
fun PolarityReportPreview() {
    PolarityReport(
        modifier = Modifier.width(300.dp),
        negPosCount = DashboardImpactReportV2.NegPosCount(100, 200)
    )
}
